import React from 'react'
import './Nav.css'
import { AiOutlineHome } from 'react-icons/ai'
import { CgUserList } from 'react-icons/cg'
import { BsBookmarkStar } from 'react-icons/bs'
import { RiServiceLine } from 'react-icons/ri'
import { TbMessages } from 'react-icons/tb'
import { AiOutlineFileDone } from 'react-icons/ai'
import { useState } from 'react'

const Nav = () => {

  const [activeNav, setActiveNev] = useState('');

  return (
    <nav>
      <a href="#" onClick={() => setActiveNev('#')} className={activeNav === '#' ? 'active' : ''}><AiOutlineHome /></a>

      <a href="#about" onClick={() => setActiveNev('#about')} className={activeNav === '#about' ? 'active' : ''}><CgUserList /></a>

      <a href="#experience" onClick={() => setActiveNev('#experience')} className={activeNav === '#experience' ? 'active' : ''}><BsBookmarkStar /></a>
      <a href="#services" onClick={() => setActiveNev('#services')} className={activeNav === '#services' ? 'active' : ''}><RiServiceLine /></a>
      <a href="#portfolio" onClick={() => setActiveNev('#portfolio')} className={activeNav === '#portfolio' ? 'active' : ''}><AiOutlineFileDone /></a>
      <a href="#contact" onClick={() => setActiveNev('#contact')} className={activeNav === '#contact' ? 'active' : ''}><TbMessages /></a>
    </nav>
  )
}

export default Nav